import controller from './comparison.controller'
import template from './comparison.html'

export default {
  template,
  controller
}
